<template>
  <div class="container pt-3 pb-1 step-3">
    <div class="row">
      <div class="col-12">
        <p class="lora h3">Rezerwacja</p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-8 order-1 order-md-0">
        <div class="md-left">
          <div class="white-panel">
            <div class="row">
              <div class="col">
                <p class="h4">Dane rezerwującego</p>

                <ul class="list-unstyled">
                  <li>{{ schema.customer.name.$model }}</li>
                  <li>e-mail: {{ schema.customer.email.$model }}</li>
                  <li>tel. {{ schema.customer.phone.$model }}</li>
                </ul>
              </div>
              <!-- EWENTUALNIE -->
              <div v-if="schema.wantInvoice.$model" class="col">
                <p class="h4">Dane do faktury</p>

                <ul class="list-unstyled">
                  <li>{{ schema.invoice.name.$model }}</li>
                  <li v-if="schema.invoice.nip.$model">NIP: {{ schema.invoice.nip.$model }}</li>
                  <li>{{ schema.invoice.postalCode.$model }} {{ schema.invoice.city.$model }}</li>
                  <li>{{ schema.invoice.street.$model }}</li>
                </ul>
              </div>
            </div>

            <div>
              <hr />
              <p class="h4">
                Do zapłaty:
                <b>{{ formatPrice(schema.priceTotal.$model) }}</b>
              </p>
              <hr />
            </div>

            <template v-if="availablePayTypes.length > 1">
              <WRadioList class="label-h4" :model="schema.payType" :values="availablePayTypes" />

              <hr />
            </template>

            <!-- JEŚLI DANE DO PRZELEWU -->
            <div v-if="schema.payType.$model === 'BankStatement'">
              <p class="h4">Dane do przelewu</p>

              <div v-html="settings.bankTransferInfo" />
            </div>

            <div v-if="schema.payType.$model === 'PayU'">
              <p class="h4">Płatność PayU</p>
            </div>

            <div>
              <WCheckbox :model="schema.consents">
                <span v-html="settings.consents" />
              </WCheckbox>

              <div class="_text-right">
                <button type="button" class="btn btn-primary pull-right" @click="submit">
                  Rezerwacja <span class="zaplata">z obowiązkiem zapłaty</span>
                </button>

                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-4 order-0 order-md-1">
        <div class="md-right">
          <SmallSummary :schema="schema" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WCheckbox from '@witkac/bootstrap4-components/src/components/checkbox';
import WRadioList from '@witkac/bootstrap4-components/src/components/radio-list';

import { formatPrice } from '@/utils/formatPrice';
import SmallSummary from './SmallSummary';

export default {
  components: { SmallSummary, WCheckbox, WRadioList },
  props: {
    schema: { type: Object, required: true },
    settings: { type: Object, required: true }
  },
  data() {
    return {
      payTypes: [
        // { value: 'BankStatement', text: 'Przelew' },
        { value: 'PayU', text: 'PayU' }
      ]
    };
  },
  computed: {
    availablePayTypes() {
      if (!this.settings.payuEnabled) {
        return this.payTypes.filter(payType => payType.value !== 2);
      }
      return this.payTypes;
    }
  },
  methods: {
    formatPrice,
    submit() {
      var errors = this.schema.$validateAll();
      if (errors && errors.length) {
        return;
      }
      this.$emit('submit');
    }
  }
};
</script>
